/**
 * @file base-usb-ota.ts
 * @description P5 PLUS / P6 PLUS Telink 底座 OTA 固件包解析。
 *
 * RapooSystem 的 `FirmwareUpgradeTelink::readBinFile` 只读取 `u32 LE @ 0x18`
 * 指定的镜像长度，并在末尾补 16 字节 `0xFF`。不接受鼠标 OTA 的其他封装格式。
 */

const SOURCE_BIN_SIZE_OFFSET = 0x18
const SOURCE_BIN_MIN_LENGTH = SOURCE_BIN_SIZE_OFFSET + 4
const TRAILER_PAD_LENGTH = 16

/** P5/P6 Telink 底座 OTA 所需的镜像数据。 */
export interface TelinkBaseOtaBin {
  size: number
  padded: Uint8Array
}

/**
 * 按 P5/P6 原厂实现解析 BIN。
 *
 * 长度字段必须落在已下载数据范围内，防止异常固件包越界读取；原厂未校验
 * 尾部 CRC，因此这里不臆加 CRC 规则。
 */
export function parseTelinkBaseOtaBin(file: Uint8Array): TelinkBaseOtaBin {
  if (file.byteLength < SOURCE_BIN_MIN_LENGTH) {
    throw new Error(`P5/P6 BIN 长度不足 ${SOURCE_BIN_MIN_LENGTH} 字节`)
  }

  const size = new DataView(file.buffer, file.byteOffset, file.byteLength).getUint32(
    SOURCE_BIN_SIZE_OFFSET,
    true,
  )
  if (size < 4 || size > file.byteLength) {
    throw new Error(`P5/P6 BIN 声明长度非法：${size}`)
  }

  const padded = new Uint8Array(size + TRAILER_PAD_LENGTH).fill(0xff)
  padded.set(file.subarray(0, size))
  return { size, padded }
}
